import { render } from "./ProjectPopupBody.vue?vue&type=template&id=774761f5&scoped=true&ts=true"
import script from "./ProjectPopupBody.vue?vue&type=script&lang=ts"
export * from "./ProjectPopupBody.vue?vue&type=script&lang=ts"

import "./ProjectPopupBody.vue?vue&type=style&index=0&id=774761f5&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774761f5"]])

export default __exports__